import { useUser } from '@clerk/clerk-react';
import { useEffect } from 'react';

import { Sentry } from '@littleotter/zz-platform/react';

export const useSentryUser = () => {
  const { user, isLoaded } = useUser();
  const client = Sentry.getClient();

  useEffect(() => {
    // If there is no client, we can't set the user context
    // This is not an error, Sentry might not be enabled or initialized, so we just return early
    if (!client || !isLoaded || !user) {
      return;
    }

    Sentry.setUser({
      id: user.id,
      externalId: user.externalId ?? undefined,
      email: user.emailAddresses[0]?.emailAddress,
      roles: Array.isArray(user.publicMetadata.roles) ? user.publicMetadata.roles.join(',') : undefined,
    });
  }, [isLoaded, user, client]);
};
